module.exports = __webpack_public_path__ + "static/media/Padroes.057fca3e.webp";